/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: DeleteFeatureDialog.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-FEATURES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * DeleteFeatureDialog - Frontend UI module: DeleteFeatureDialog.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: контракты функций, парные END_METHOD, блок удаления.
 * END_CHANGE_SUMMARY
 */

import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

/* START_METHOD_DeleteFeatureDialog */
/* START_CONTRACT: DeleteFeatureDialog
 * PURPOSE: Диалог подтверждения удаления задачи.
 * INPUTS: { open: boolean, onClose: ()=>void, onConfirm: (id)=>Promise, feature: Feature }.
 * OUTPUTS: { JSX.Element|null - диалог }.
 * SIDE_EFFECTS: вызов onConfirm (HTTP наверх); локальный state.
 * LINKS: M-FE-FEATURES
 * END_CONTRACT: DeleteFeatureDialog
 */
export default function DeleteFeatureDialog({ open, onClose, onConfirm, feature }) {
  const [loading, setLoading] = useState(false);

  if (!feature) return null;

  /* START_METHOD_handleConfirm */
  /* START_CONTRACT: handleConfirm
   * PURPOSE: Удалить задачу; при успехе закрыть диалог.
   * INPUTS: {}.
   * OUTPUTS: { Promise<void> }.
   * SIDE_EFFECTS: onConfirm (HTTP); setLoading; onClose.
   * LINKS: M-FE-FEATURES
   * END_CONTRACT: handleConfirm
   */
  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm(feature.id);
      /* START_BLOCK_DELETE_OK */
      onClose();
      /* END_BLOCK_DELETE_OK */
    } finally {
      setLoading(false);
    }
  };
  /* END_METHOD_handleConfirm */

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: '1rem' }}>Удаление задачи</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Вы действительно хотите удалить задачу &laquo;{feature.name}&raquo;?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={handleConfirm}
          disabled={loading}
        >
          Удалить
        </Button>
        <Button size="small" onClick={onClose} disabled={loading}>
          Отмена
        </Button>
      </DialogActions>
    </Dialog>
  );
}
/* END_METHOD_DeleteFeatureDialog */
